import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import PriceConfigurationTables from '@features/crm/brands/components/pricing/PriceConfigurationTables';
import ConfirmationModal from '@features/crm/components/ConfirmationModal';

import {
	fetchPriceRangeTableDataById,
	fetchProfitMarginTableDataById
} from '@store/actions/BrandProfileAction';

import { onPricingEnabled } from '@services/crmService';

const Pricing = () => {
	const brandProfileStore = useSelector((store) => store.brandProfileStore);
	const [isPriceEnable, setIsPriceEnable] = useState(brandProfileStore?.pickAndChooseEnabled);
	const [showConfirmationModal, setShowConfirmationModal] = useState(false);
	const { id } = useParams();
	const dispatch = useDispatch();

	const priceRangeTableData = useSelector((store) => store.brandProfileStore.priceRangeTableData);
	const profitMarginTableData = useSelector((store) => store.brandProfileStore.profitMarginTableData);

	useEffect(() => {
		dispatch(fetchPriceRangeTableDataById(`${id}`));
		dispatch(fetchProfitMarginTableDataById(`${id}`));
	}, [dispatch, id]);

	const onPricingToggle = async () => {
		if (isPriceEnable) {
			if (priceRangeTableData.length > 0) {
				setShowConfirmationModal(true);
			} else {
				await onPricingEnabled(id, false);
				setIsPriceEnable(false);
			}
		} else {
			await onPricingEnabled(id, true);
			setIsPriceEnable(true);
		}
	};

	const onPricingOff = async () => {
		await onPricingEnabled(id, false);
		setIsPriceEnable(false);
		setShowConfirmationModal(false);
	};

	const onCloseConfirmationModal = () => {
		setShowConfirmationModal(false);
	};

	return (
		<div className="py-3 px-4">
			<div className="d-flex align-items-center">
				<p className="regular-14 gray_dark_01 mr-2">P&C Price Configuration</p>
				<img
					src={
						isPriceEnable
							? `${process.env.PUBLIC_URL}/icons/toggle-on.svg`
							: `${process.env.PUBLIC_URL}/icons/toggle-off.svg`
					}
					alt="toggle"
					className="cursor-pointer"
					onClick={onPricingToggle}
				/>
			</div>
			<PriceConfigurationTables
				priceRangeTableData={priceRangeTableData}
				profitMarginTableData={profitMarginTableData}
			/>
			{showConfirmationModal && (
				<ConfirmationModal
					title={'Disable P&C Price Configuration?'}
					closeModal={onCloseConfirmationModal}
					description={
						'to turn off the P&C Price Configuration? Buyers will lose access to price visibility.'
					}
					callback={onPricingOff}
				/>
			)}
		</div>
	);
};

export default Pricing;
